import { Type } from "class-transformer";
import { IEntity } from "@interfaces/entity";
import { User } from "../identity/user";
import { Role } from "./role";
import { Customer } from "@models/customer";

export class UserRole {
  user: User;

  @Type(() => Role)
  role: Role;

  customerId: number;
  customer: Customer;
}
